import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { replaceUrlParam } from "../common/utils";

import Calculator from "../features/products/Calculator";
import { checkFieldUpdate } from "../common/utils";

import Editor from "./Editor";
import Input from "@material-ui/core/Input";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Container from "@material-ui/core/Container";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Divider from "@material-ui/core/Divider";
import format from "date-fns/format";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";

import DropZone from "./DropZone";
import Datepicker from "../common/Datepicker";

import CategoriesSelect from "./CategoriesSelect";
import Brand from "../features/brands/Brand";
import Client from "../features/clients/Client";
import Supplier from "../features/suppliers/Supplier";
import Category from "../features/categories/Category";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import AutocompleteInput from "../common/Autocomplete";

import { useLocation } from "react-router-dom";

import {
  updateProduct,
  createProduct,
  priceCalculator,
  selectProducts,
  fetchProducts,
  fetchProductsByGroup,
  fetchProductHistory,
  fetchProductByID,
  getFullList,
} from "../features/products/productsSlice";

const ColorButton = withStyles((theme) => ({
  root: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  cardBase: {
    padding: theme.spacing(3),
    margin: theme.spacing(3, 0),
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px",
    padding: 0,
  },

  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },

  dropzoneContainer: {},

  input: {
    display: "none",
  },
  multiContainer: {},
  multiDisplay: {},
  chip: {
    textAlign: "left",
    fontSize: 12,
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },

  prodStatusAccordion: {
    maxWidth: "35%",
  },

  prodStatusInput: {
    width: "100%",
  },

  prodStatusInputsContainer: {},
  prodStatusInputGrid: {
    display: "flex",
    alignItems: "center",
  },

  prodInfoContainer: {},

  prodInfoGrid: {
    maxWidth: 650,
  },

  mediaDetails: {
    width: "100%",
  },
  formControl: {
    marginBottom: 6,
    minWidth: 120,
    width: "100%",
    maxWidth: 400,
  },
  informationTexts: {
    width: "100%",
  },
  detailsItem: {
    padding: 8,
    width: "100%",
  },
  title: {
    color: "#fff",
    padding: 16,
    backgroundColor: theme.palette.secondary.main,
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
  },
  subtitle: { color: theme.palette.secondary.main, marginBottom: 5 },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },

  getContentAnchorEl: null,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ProductPage(props) {
  const {
    brandsList,
    suppliersList,
    clientsList,
    categoriesTree,
    products,
    product,
    handlePriceCalculation,
    edit,

    code,
    setCode,
    name,
    setName,
    shortDesc,
    setShortDesc,
    statuses,
    rrp,
    setRRP,
    sellingPrice,
    freight,
    setFreight,
    costPrice,
    setCostPrice,
    margin,
    setMargin,
    productStatus,
    setProductStatus,
    productSupplier,
    setProductSupplier,
    selectedBrand,
    setBrand,
    editorValue,
    setEditorValue,
    checked,
    setCategoriesChecked,
    names,
    setNames,
    excludedClients,
    setExcludedClients,
    brandIDs,
    setBrandIDs,
    supplierIDs,
    setSupplierIDs,
    statusIDs,
    setStatusIDs,
    statusList,
    featured,
    special,
    specialSellingPrice,
    specialOfferDescription,
    specialEndDate,
    setFeatured,
    setSpecial,
    setSpecialSellingPrice,
    setSpecialOfferDescription,
    setSpecialEndDate,
    images,
    setImages,
    setLocalization,
    localization,
  } = props;

  // console.log(
  //   "margin, costPrice, freight, rrp ",
  //   margin,
  //   costPrice,
  //   freight,
  //   rrp
  // );
  const dispatch = useDispatch();
  const history = useHistory();

  const classes = useStyles();
  let jwtToken = localStorage.getItem("coreToken");
  const {
    lastQuery,
    productGroupList,
    productList,
    loading,
    productHistory,
    productsAmount,
  } = useSelector(selectProducts);

  console.log("product", product);

  const location = useLocation();

  // useEffect(() => {
  //   if (location.pathname.includes("/edit") && !product.id) {
  //     dispatch(fetchProductByID({ token: jwtToken, id: product.id }));
  //   }
  // }, [location]);

  const selectProduct = useSelector(selectProducts);

  const timeoutRef = React.useRef(null);

  //live price calculation on values input
  let timeout = null;

  useEffect(() => {
    if (edit && product.id) {
      dispatch(fetchProductHistory({ token: jwtToken, id: product.id }));
    }
  }, [dispatch]);

  const timeZoneOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZone: "Australia/Sydney",
  };

  const shallowEqual = (object1, object2) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (let key of keys1) {
      if (object1[key] !== object2[key]) {
        return false;
      }
    }
    return true;
  };

  //-------------------------------------
  // Product Grouping
  //-------------------------------------

  const [groupingDialogOpen, setGroupingDialogOpen] = useState(false);
  const [groupProducts, setGroupProducts] = useState([{}]);
  const [disableGroupUpdate, setDisableGroupUpdate] = useState(true);

  useEffect(() => {
    if (edit && product.id)
      if (!productGroupList.data.length && loading == "loaded") {
        console.log("fetching here");
        console.log("productGroupList.data", productGroupList.data);
        dispatch(
          fetchProductsByGroup({ token: jwtToken, groupID: product.groupID })
        );
      } else {
        setGroupProducts(productGroupList.data);
      }

    //Move this to a search that occurs after 3 letters
    let searchQuery = "?limit=100&statuses=1";
    // dispatch(
    //   getFullList({
    //     token: jwtToken,
    //     offset: productList.data.length,
    //     query: searchQuery,
    //     targetLength: 2000,
    //   })
    // );
  }, []);

  useEffect(() => {    
    if (location.pathname.includes("/edit") && !product.id) {
      dispatch(fetchProductByID({ token: jwtToken, id: location.pathname.split("/").reverse()[0] }));
    }
  }, []);

  useEffect(() => {
    let disabled = true;
    for (var i = 0; i < groupProducts.length; i++) {
      if (
        (groupProducts[i].groupCriteriaColour != null &&
          groupProducts[i].groupCriteriaColour != "") ||
        (groupProducts[i].groupCriteriaSize !== null &&
          groupProducts[i].groupCriteriaSize !== "")
      ) {
        disabled = false;
      } else {
        disabled = true;
        break;
      }
    }
    setDisableGroupUpdate(disabled);
  }, [groupProducts]);

  useEffect(() => {
    if (
      productGroupList.data.some(
        (product) => !groupProducts.some((prod) => product.id == prod.id)
      )
    ) {
      addGroupedProducts();
    }
    // if (!productGroupList.data.length) {
    //   console.log('Loading more')
    //   dispatch(
    //     fetchProductsByGroup({
    //       token: jwtToken,
    //       groupID: product.groupID,
    //     })
    //   );
    // }
    if (groupProducts[0] && !groupProducts[0].id) {
      setGroupProducts(productGroupList.data);
    }
  }, [productGroupList]);

  const openGroupingDialog = () => {
    // console.log("productGroupList.data", productGroupList.data);

    setGroupProducts(productGroupList.data);
    setGroupingDialogOpen(true);
  };

  const addNewGroupProduct = () => {
    let newGroupProducts = [...groupProducts];
    newGroupProducts.push({});
    setGroupProducts(newGroupProducts);
  };

  const handleRelatedProductChange = (e, relatedProduct, index) => {
    let newGroupProducts = [...groupProducts];
    newGroupProducts[index] = relatedProduct ? relatedProduct : {};
    setGroupProducts(newGroupProducts);
    if (relatedProduct) {
      dispatch(
        fetchProductsByGroup({
          token: jwtToken,
          groupID: relatedProduct.groupID,
        })
      );
      // addGroupedProducts(st);
    }
  };

  const addGroupedProducts = () => {
    let newGroupProducts = [...groupProducts];
    const newProducts = productGroupList.data.filter(
      (product) => !groupProducts.some((prod) => product.id == prod.id)
    );
    setGroupProducts(newGroupProducts.concat(newProducts));
  };

  const handleUpdateGrouping = () => {
    let updateGroupProducts = groupProducts.map((product, index) => ({
      ...product,
      groupID: groupProducts[groupProducts.length - 1].groupID,
    }));

    [
      ...updateGroupProducts.filter((elem) => elem.id === product.id),
      ...updateGroupProducts.filter((elem) => elem.id !== product.id),
    ].map((product, index) => {
      let updatedProduct;
      if (product.markedForRemoval) {
        updatedProduct = {
          groupID: uuidv4(),
          groupCriteriaColour: product.groupCriteriaColour,
          groupCriteriaSize: product.groupCriteriaSize,
        };
      } else {
        updatedProduct = {
          groupID: product.groupID,
          groupCriteriaColour: product.groupCriteriaColour,
          groupCriteriaSize: product.groupCriteriaSize,
        };
      }

      dispatch(
        updateProduct({
          token: jwtToken,
          product: updatedProduct,
          id: product.id,
          catIDs: [],
          removedCats: [],
          images: [],
          excludedClients: [],
          includedClients: [],
          imageChange: {
            imagesAdded: [],
            imagesRemoved: [],
            imagesUpdated: [],
          },
          groupID: updatedProduct,
          firstInGroup: index == 0 ? true : false,
        })
      );
    });
    setGroupProducts([{}]);

    // history.push("/products");
  };

  const [menuPosition, setMenuPosition] = useState(null);

  const inputLabel = useRef(null);
  const handleBrandsChange = (event) => {
    let selectedBrand = brandsList.filter(
      (brand) => brand.name === event.target.value
    );
    selectedBrand && setBrandIDs(selectedBrand[0].id);

    setBrand(event.target.value);
  };

  const handleSuppliersChange = (event) => {
    let selectedSupplier = suppliersList.filter(
      (supplier) => supplier.name === event.target.value
    );
    selectedSupplier[0] && setSupplierIDs(selectedSupplier[0].id);

    setProductSupplier(event.target.value);
  };

  const handleStatusChange = (event) => {
    let selectedStatus = statusList.filter(
      (status) => status.value === event.target.value
    );
    selectedStatus[0] && setStatusIDs(selectedStatus[0].id);

    setProductStatus(event.target.value);
  };

  function handleChange(event) {
    setExcludedClients(event.target.value);
  }

  const grp = [
    "aegrewards.com.au",
    "augertorquerewards.com",
    "jdgplusrewards.com.au",
    "lwpclub.com.au",
    "psxdemo.com.au",
    "rewards.premierdealerprogram.com.au",
    "tamarewards.com.au",
    "waratahrewards.com.au",
    "alliancerewards.net.au",
  ];

  const [categoriesChanged, setCategoriesChanged] = useState(false);

  const handleToggle = (e, value, name) => {
    e.stopPropagation();
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    const currentNameIndex = names.indexOf(name);
    const newNames = [...names];

    if (currentNameIndex === -1) {
      newNames.push(name);
    } else {
      newNames.splice(currentNameIndex, 1);
    }
    setNames(newNames);
    setCategoriesChecked(newChecked);
    setCategoriesChanged(true);
  };

  const filterByName = (arr, property, searchStr) => {
    const test = arr.filter((x) => x[property].includes(searchStr));
    return test;
  };

  const getImageName = (image) => {
    return image.objName.includes("images/")
      ? image.objName.split("images/")[1].split("_")[0]
      : image.objName;
  };

  const updateAltTexts = (text, imageIndex, selectedImage) => {
    const newImages = images.map((image, index) => {
      if (imageIndex === index) {
        // check if fieldName equals to cityId
        return {
          ...image,
          altText: text,
        };
      } else if (
        filterByName([image], "objName", getImageName(selectedImage)).length
      ) {
        return {
          ...image,
          altText: text,
        };
      } else {
        return image;
      }
    });
    setImages(newImages);
  };

  const updateMediaTitles = (title, imageIndex, selectedImage) => {
    // let name = image.objName.split("images/")[1].split('_')[0]

    const newImages = images.map((image, index) => {
      if (imageIndex === index) {
        // check if fieldName equals to cityId
        return {
          ...image,
          title: title,
        };
      } else if (
        filterByName([image], "objName", getImageName(selectedImage)).length
      ) {
        return {
          ...image,
          title: title,
        };
      } else {
        return image;
      }
    });
    setImages(newImages);
  };

  const filesCB = (filesList) => {
    if (filesList.length) {
      const file = filesList[filesList.length - 1];
      let objName = URL.createObjectURL(file);
      let imageFile = {
        id: uuidv4(),
        objName: objName,
        name: file.name,
        file: file,
      };

      setImages((images) => {
        return [...images, imageFile];
      });
    }
  };

  const removeImage = (e, url) => {
    const imageName = getImageName({ objName: url });
    let updatedUrls = images.filter(
      (image) => !image.objName.includes(imageName)
    );
    setImages(updatedUrls);
  };

  const handleSave = (e) => {
    e.preventDefault();
    const excludedIDs = [];
    if (excludedClients.length) {
      excludedClients.forEach((client) => {
        let excluded = clientsList.filter((c) => c.name === client);
        if (excluded.length) {
          excludedIDs.push(excluded[0].id);
        }
      });
    }

    const newProduct = {
      groupID: uuidv4(),
      statusID: statusIDs,
      brandID: brandIDs,
      supplierID: supplierIDs,
      sku: code,
      name: name,
      CostPrice: Math.round(Number(costPrice) * 100),
      l10nID: Number(localization),
      freight: Math.round(Number(freight) * 100),
      rrp: Math.round(Number(rrp) * 100),
      margin: Number(margin) / 100,
      modelNumber: null,
      weight: null,
      weightUnit: null,
      dimensions: null,
      groupPrimary: false,
      featured: featured,
      special: special,
      shortDescription: shortDesc,
      longDescription: `${editorValue}`,
      specialSellingPrice: Math.round(Number(specialSellingPrice) * 100),
      specialOfferDescription: specialOfferDescription,
    };
    if (specialEndDate) {
      newProduct.specialEndDate = format(specialEndDate, "yyyy-MM-dd");
    }
    if (Number(margin) <= 100) {
      dispatch(
        createProduct({
          catIDs: checked,
          token: jwtToken,
          product: newProduct,
          images: images,
          excludedClients: excludedIDs,
        })
      );
    }
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const updatedProduct = {
      statusID: statusIDs,
      brandID: brandIDs,
      supplierID: supplierIDs,
      sku: code,
      name: name,
      costPrice: Math.round(Number(costPrice) * 100),
      l10nID: Number(localization),
      // purchasePrice: Math.round(Number(pointsShopPrice) * 100),
      freight: Math.round(Number(freight) * 100),
      rrp: Math.round(Number(rrp) * 100),
      margin: Number(margin) / 100,
      featured: featured,
      special: special,
      shortDescription: shortDesc,
      longDescription: `${editorValue}`,
      specialSellingPrice: Math.round(Number(specialSellingPrice) * 100),
      specialOfferDescription: specialOfferDescription,
    };

    if (specialEndDate) {
      // don't format the date field if it is a string returned from api
      updatedProduct.specialEndDate =
        typeof specialEndDate === "string"
          ? specialEndDate
          : format(specialEndDate, "yyyy-MM-dd");
    }

    const updatedProductFields = checkFieldUpdate(
      [
        { name: "statusID", val: statusIDs },
        { name: "brandID", val: brandIDs },
        { name: "supplierID", val: supplierIDs },
        { name: "sku", val: code },
        { name: "name", val: name },
        { name: "costPrice", val: Math.round(Number(costPrice) * 100) },
        { name: "l10nID", val: Number(localization) },
        { name: "freight", val: Math.round(Number(freight) * 100) },
        { name: "rrp", val: Math.round(Number(rrp) * 100) },
        { name: "margin", val: Number(margin) / 100 },
        { name: "featured", val: featured },
        { name: "special", val: special },
        { name: "shortDescription", val: shortDesc },
        { name: "longDescription", val: `${editorValue}` },
        {
          name: "specialSellingPrice",
          val: Math.round(Number(specialSellingPrice) * 100),
        },
        { name: "specialOfferDescription", val: specialOfferDescription },
        {
          name: "specialEndDate",
          val:
            specialEndDate === null
              ? null
              : typeof specialEndDate === "string"
              ? specialEndDate
              : format(specialEndDate, "yyyy-MM-dd"),
        },
      ],
      product
    );

    console.log("updatedProductFields: ", updatedProductFields);

    let imageChange = {
      imagesAdded: [],
      imagesRemoved: [],
      imagesUpdated: [],
    };

    product.images &&
      images &&
      product.images.forEach((prodImage) => {
        const imageCurrent = images.filter(
          (image) => image.id === prodImage.id
        );
        if (!imageCurrent.length) {
          imageChange.imagesRemoved.push(prodImage);
        }
      });

    if (!product.images && images) {
      images.forEach((image) => {
        imageChange.imagesAdded.push(image);
      });
    }

    product.images &&
      images &&
      images.forEach((image) => {
        const addImage = product.images.filter(
          (prodImage) => prodImage.id === image.id
        );
        if (!addImage.length) {
          imageChange.imagesAdded.push(image);
        } else if (image !== addImage[0]) {
          imageChange.imagesUpdated.push(image);
        }
      });

    let removedIDs = [];
    let addedIDs = [];
    let productExcludedIDs =
      product.excludedClients && product.excludedClients.length
        ? product.excludedClients.map((client) => client.name)
        : [];
    if (product.excludedClients) {
      if (!excludedClients.length) {
        removedIDs = product.excludedClients.map((client) => client.id);
      } else {
        product.excludedClients.forEach((excluded) => {
          let removed = excludedClients.indexOf(excluded.name);
          removed === -1 && removedIDs.push(excluded.id);
        });
      }
    }

    console.log("excludedClients", excludedClients);

    if (excludedClients.length) {
      excludedClients.forEach((excluded) => {
        let added = productExcludedIDs.length
          ? productExcludedIDs.indexOf(excluded)
          : -1;
        added === -1 &&
          addedIDs.push(
            clientsList.filter((client) => client.name === excluded)[0].id
          );
      });
    }

    console.log("addedIDs", addedIDs);
    console.log("removedIDs", removedIDs);

    if (Number(margin) <= 100) {
      dispatch(
        updateProduct({
          token: jwtToken,
          product: updatedProductFields,
          id: product.id,
          catIDs: categoriesChanged ? checked : [],
          images: images,
          imageChange: imageChange,
          excludedClients: addedIDs,
          includedClients: removedIDs,
        })
      );

      // .then(() => {
      //   fetchProductByID({ token: jwtToken, id: product.id });
      // });
    }
  };

  const handleCatsOpen = (event) => {
    if (menuPosition) {
      return;
    }
    event.preventDefault();
    setMenuPosition({
      top: event.clientY,
      left: event.clientX,
    });
  };

  const handleBack = () => {
    dispatch(fetchProducts({ token: jwtToken, query: lastQuery }));
    history.goBack();
  };

  // console.log("*** product ***", product);

  const uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };  

  return (
    <div className={classes.root}>
      <Dialog
        open={groupingDialogOpen}
        onClose={() => {
          setGroupingDialogOpen(false);
        }}
      >
        <DialogTitle
          disableTypography
          className={classes.title}
          id="form-dialog-title"
        >
          Edit Product Grouping
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            style={{ paddingTop: 16, textAlign: "center", marginBottom: 32 }}
          >
            Add related products to a group - enter the related criteria (size,
            colour or both)
          </DialogContentText>
          Add Related Products
          <ColorButton
            style={{ marginLeft: 32 }}
            onClick={addNewGroupProduct}
            color="secondary"
          >
            Add Another Product
          </ColorButton>
          <Divider style={{ marginBottom: 10, marginTop: 5 }} />
          {groupProducts &&
            [
              ...groupProducts.filter((elem) => elem.id === product.id),
              ...groupProducts.filter((elem) => elem.id !== product.id),
            ].map((relatedProduct, index) => (
              <Grid item sm key={index}>
                {index == 0 && (
                  <div style={{ color: "blue" }}>Current Product</div>
                )}
                <AutocompleteInput
                  name={"related-product"}
                  list={
                    productList.data &&
                    productList.data.filter(
                      (product) =>
                        !groupProducts.some((prod) => product.id == prod.id)
                    )
                  }
                  index={index}
                  key={index}
                  setSelectedOption={handleRelatedProductChange}
                  selectedVal={relatedProduct ? relatedProduct : null}
                />
                <div style={{ display: "flex" }}>
                  <TextField
                    key={product.name}
                    value={
                      relatedProduct ? relatedProduct.groupCriteriaColour : ""
                    }
                    variant="outlined"
                    // margin="normal"
                    margin="dense"
                    id="colour-criteria"
                    label={
                      relatedProduct.groupCriteriaColour
                        ? relatedProduct.groupCriteriaColour
                        : "Colour"
                    }
                    onChange={(e) => {
                      let newGroupProducts = [...groupProducts];
                      let newProduct = { ...newGroupProducts[index] };

                      newProduct.groupCriteriaColour = e.target.value;
                      newGroupProducts[index] = newProduct;
                      setGroupProducts(newGroupProducts);
                    }}
                    style={{ paddingRight: 10 }}
                  />
                  <TextField
                    key={product.name}
                    value={
                      relatedProduct ? relatedProduct.groupCriteriaSize : ""
                    }
                    variant="outlined"
                    // margin="normal"
                    margin="dense"
                    id="size-criteria"
                    label={
                      relatedProduct.groupCriteriaSize
                        ? relatedProduct.groupCriteriaSize
                        : "Size"
                    }
                    onChange={(e) => {
                      let newGroupProducts = [...groupProducts];
                      let newProduct = { ...newGroupProducts[index] };

                      newProduct.groupCriteriaSize = e.target.value;
                      newGroupProducts[index] = newProduct;
                      setGroupProducts(newGroupProducts);
                    }}
                  />
                  <div
                    style={{
                      display:
                        relatedProduct.id === product.id ? "none" : "block",
                    }}
                  >
                    <Checkbox
                      checked={product.markedForRemoval}
                      onChange={(e) => {
                        let newGroupProducts = [...groupProducts];
                        let newProduct = { ...newGroupProducts[index] };
                        if (!newProduct.id) {
                          newGroupProducts.splice(index, 1);
                        } else {
                          newProduct.markedForRemoval = e.target.checked;
                          newGroupProducts[index] = newProduct;
                        }
                        setGroupProducts(newGroupProducts);
                      }}
                    />
                    <span style={{ fontSize: 10 }}>Remove from Group</span>
                  </div>
                </div>
                <Divider style={{ marginBottom: 5, marginTop: 5 }} />
              </Grid>
            ))}
        </DialogContent>
        <DialogActions style={{ padding: 24 }}>
          <Grid container spacing={2} direction="row">
            <Grid item sm>
              <ColorButton
                onClick={() => {
                  setGroupingDialogOpen(false);
                }}
                color="primary"
              >
                Cancel
              </ColorButton>
            </Grid>
            <Grid item sm>
              <ColorButton
                onClick={handleUpdateGrouping}
                disabled={disableGroupUpdate}
                color="secondary"
              >
                Update Product Group
              </ColorButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      {/* {products.loading !== "loading" && ( */}
      <form
        style={{ display: "flex" }}
        onSubmit={edit ? handleUpdate : handleSave}
      >
        <Button
          variant="contained"
          color="primary"
          component="span"
          onClick={handleBack}
          style={{
            maxHeight: 36.5,
          }}
        >
          Back
        </Button>
        <Container className={classes.paper} component="main" fixed>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                Product Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid
                container
                spacing={3}
                direction="column"
                justifyContent="space-between"
              >
                <Grid
                  container
                  spacing={3}
                  direction="row"
                  justifyContent="space-between"
                  style={{
                    padding: 12,
                    paddingTop: 0,
                    paddingBottom: 18,
                  }}
                >
                  <Grid item sm>
                    <Grid
                      container
                      spacing={1}
                      direction="column"
                      justifyContent="space-between"
                    >
                      <Grid
                        item
                        sm
                        className={classes.detailsItem}
                        margin="dense"
                      >
                        <TextField
                          key={product.sku}
                          defaultValue={edit ? product.sku : ""}
                          variant="outlined"
                          // margin="normal"
                          required
                          fullWidth
                          margin="dense"
                          id="code"
                          label="Product Code"
                          name="code"
                          autoComplete="text"
                          inputProps={{ maxLength: 255 }}
                          onChange={(e) => setCode(e.target.value)}
                        />
                      </Grid>
                      <Grid
                        item
                        sm
                        className={classes.detailsItem}
                        margin="dense"
                      >
                        <TextField
                          key={product.name}
                          defaultValue={edit ? product.name : ""}
                          variant="outlined"
                          // margin="normal"
                          required
                          fullWidth
                          margin="dense"
                          id="name"
                          label="Name"
                          name="name"
                          autoComplete="name"
                          inputProps={{ maxLength: 255 }}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </Grid>
                      <Grid
                        item
                        sm
                        className={classes.detailsItem}
                        margin="dense"
                      >
                        <TextField
                          key={product.shortDescription}
                          defaultValue={edit ? product.shortDescription : ""}
                          id="outlined-multiline-desc"
                          label="Short Description"
                          multiline
                          fullWidth
                          margin="dense"
                          rows={4}
                          inputProps={{ maxLength: 255 }}
                          variant="outlined"
                          onChange={(e) => setShortDesc(e.target.value)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Grid item sm={1}>
                    <Divider variant="vertical" />
                  </Grid> */}
                  <Grid item sm>
                    <Grid
                      container
                      spacing={1}
                      direction="column"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      {/* <Grid
                  className={classes.prodInfoGrid}
                  container
                  spacing={3}
                  direction="row"
                  justifyContent="space-between"
                > */}
                      <Grid
                        item
                        sm
                        className={classes.detailsItem}
                        margin="dense"
                      >
                        <TextField
                          className={classes.informationTexts}
                          key={product.rrp}
                          // defaultValue={
                          //   edit
                          //     ? (product.rrp / 100).toFixed(2).toString()
                          //     : ''
                          // }
                          value={rrp}
                          variant="outlined"
                          // margin="normal"
                          required
                          margin="dense"
                          id="rrp"
                          label="RRP ($)"
                          name="rrp"
                          autoComplete="text"
                          onChange={(e) => setRRP(e.target.value)}
                        />
                      </Grid>

                      <Grid
                        item
                        sm
                        className={classes.detailsItem}
                        margin="dense"
                      >
                        <TextField
                          className={classes.informationTexts}
                          key={product.freight}
                          // defaultValue={
                          //   edit
                          //     ? (product.freight / 100).toFixed(2).toString()
                          //     : ''
                          // }
                          value={freight}
                          variant="outlined"
                          // margin="normal"
                          required
                          margin="dense"
                          id="freight"
                          label="Freight ($)"
                          name="freight"
                          autoComplete="text"
                          onChange={(e) => setFreight(e.target.value)}
                        />
                      </Grid>
                      {/* </Grid> */}
                      {/* <Grid
                  container
                  spacing={3}
                  direction="row"
                  justifyContent="space-between"
                  className={classes.prodInfoGrid}
                > */}
                      <Grid
                        item
                        sm
                        className={classes.detailsItem}
                        margin="dense"
                      >
                        <TextField
                          className={classes.informationTexts}
                          key={product.costPrice}
                          // defaultValue={
                          //   edit
                          //     ? (product.costPrice / 100).toFixed(2).toString()
                          //     : ''
                          // }
                          value={costPrice}
                          variant="outlined"
                          // margin="normal"
                          required
                          margin="dense"
                          id="cost-price"
                          label="Cost Price ($)"
                          name="cost-price"
                          autoComplete="name"
                          onChange={(e) => setCostPrice(e.target.value)}
                        />
                      </Grid>

                      <Grid
                        item
                        sm
                        className={classes.detailsItem}
                        margin="dense"
                      >
                        <TextField
                          className={classes.informationTexts}
                          key={`${sellingPrice + "-margin"}`}
                          // defaultValue={
                          //   margin
                          //     ? edit
                          //       ? Number(margin).toFixed(2).toString()
                          //       : margin
                          //     : ''
                          // }
                          value={margin === '-100.0000' ? '0' : margin}
                          variant="outlined"
                          // disabled
                          // margin="normal"
                          margin="dense"
                          id="margin"
                          label="Margin (%)"
                          name="margin"
                          onChange={(e) => setMargin(e.target.value)}
                          error={margin >= 100}
                          helperText={
                            margin >= 100
                              ? "Margin cannot be greater than 100%"
                              : ""
                          }
                        />
                      </Grid>
                      <Grid
                        item
                        sm
                        className={classes.detailsItem}
                        margin="dense"
                      >
                        <TextField
                          className={classes.informationTexts}
                          key={sellingPrice}
                          defaultValue={
                            sellingPrice
                              ? edit
                                ? sellingPrice
                                : sellingPrice.toFixed(2).toString()
                              : ""
                            // edit
                            //   ? (sellingPrice / 100).toFixed(2).toString()
                            //   : ''
                          }
                          disabled
                          variant="outlined"
                          // margin="normal"
                          margin="dense"
                          id="points-price"
                          label="Selling Price ($) - locked"
                          name="points-price"
                          autoComplete="name"
                          // onChange={(e) => setSellingPrice(e.target.value)}
                        />
                      </Grid>
                      {/* </Grid> */}
                    </Grid>
                    <Grid
                      item
                      sm
                      className={classes.detailsItem}
                      margin="dense"
                    >
                      <Calculator
                        handlePriceCalculation={handlePriceCalculation}
                        productPage={true}
                        product={product}
                        edit={edit}
                      />

                      {/* </Grid> */}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item>
                  <Divider />
                </Grid>
                <Grid
                  style={{
                    textAlign: "left",
                    color: "rgba(0, 0, 0, 0.54)",
                    fontSize: "1rem",
                    paddingBottom: 0,
                  }}
                  item
                  sm
                >
                  Product Description
                </Grid>
                <Grid
                  item
                  sm
                  style={{
                    paddingTop: 0,
                  }}
                >
                  <Editor
                    editorValue={editorValue}
                    setEditorValue={setEditorValue}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className={classes.heading}>Product Data</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid
                container
                spacing={3}
                direction="column"
                justifyContent="space-between"
              >
                <Grid item sm>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item sm style={{ paddingTop: 0 }}>
                      <Grid
                        container
                        spacing={0}
                        direction="row"
                        style={{ flexFlow: "row nowrap" }}
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <FormControl
                          onClick={handleCatsOpen}
                          variant="outlined"
                          margin="dense"
                          className={classes.formControl}
                        >
                          <InputLabel id="multiple-checkbox-label-categories">
                            Categories*
                          </InputLabel>
                          <Select
                            margin="dense"
                            labelId="multiple-checkbox-label-categories"
                            id="multiple-checkbox-categories"
                            required
                            // className={classes.multiContainer}
                            multiple
                            disabled
                            value={names}
                            input={
                              <Input
                                className={classes.multiContainer}
                                multiple
                              />
                            }
                            displayEmpty
                            renderValue={(selected) => selected ? selected.join(", ") : ""} 
                            MenuProps={MenuProps}
                          ></Select>
                        </FormControl>
                        <CategoriesSelect
                          menuPosition={menuPosition}
                          setMenuPosition={setMenuPosition}
                          // handleOpen={handleCatsOpen}
                          checked={checked}
                          names={names}
                          handleToggle={handleToggle}
                          categoryTreeList={categoriesTree}
                          edit={edit}
                          prodCategories={edit ? product.categories : []}
                          list={false}
                          classes={classes}
                        />
                        <Category
                          product={true}
                          handleToggle={handleToggle}
                          categoriesTree={categoriesTree}
                          classes={classes}
                        />
                      </Grid>
                    </Grid>
                    <Grid item sm style={{ paddingTop: 0 }}>
                      <Grid
                        container
                        spacing={0}
                        direction="row"
                        style={{ flexFlow: "row nowrap" }}
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <FormControl
                          margin="dense"
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <InputLabel id="multiple-checkbox-label-sites">
                            Excluded Clients
                          </InputLabel>
                          <Select
                            margin="dense"
                            labelId="multiple-checkbox-label-sites"
                            id="multiple-checkbox-sites"
                            // className={classes.multiContainer}
                            multiple
                            value={
                              selectProduct.excludedClients
                                ? selectProduct.excludedClients
                                : excludedClients
                            }
                            onChange={handleChange}
                            input={
                              <Input
                                className={classes.multiContainer}
                                multiple
                              />
                            }
                            displayEmpty
                            renderValue={(selected) => selected ? selected.join(", ") : ""}
                            MenuProps={MenuProps}
                          >
                            {clientsList
                              .map((client) => client.name)
                              .map((site) => (
                                <MenuItem key={site} value={site}>
                                  <Checkbox
                                    checked={
                                      excludedClients
                                        ? excludedClients.indexOf(site) > -1
                                        : false
                                    }
                                  />
                                  <ListItemText primary={site} />
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                        <Client product={true} />
                      </Grid>
                    </Grid>
                    <Grid item sm style={{ paddingTop: 24 }}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        style={{
                          width: "100%",
                        }}
                      >
                        <InputLabel
                          htmlFor="outlined-localization-simple"
                          margin="dense"
                        >
                          Product Country*
                        </InputLabel>
                        <Select
                          value={localization}
                          onChange={(e) => setLocalization(e.target.value)}
                          margin="dense"
                          required
                          label="Client Country"
                          inputProps={{
                            name: "localization",
                            id: "outlined-localization-simple",
                          }}
                        >
                          <MenuItem value="1">Australia</MenuItem>
                          <MenuItem value="2">New Zealand</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item sm style={{ paddingTop: 0, display: "none" }}>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel id="multiple-checkbox-label-group">
                          Product Group (disabled)
                        </InputLabel>
                        <Select
                          margin="dense"
                          labelId="multiple-checkbox-label-group"
                          id="multiple-checkbox-group"
                          // className={classes.multiContainer}
                          multiple
                          disabled
                          value={[]}
                          // onChange={handleChange}
                          input={
                            <Input
                              className={classes.multiContainer}
                              multiple
                            />
                          }
                          displayEmpty
                          renderValue={(selected) => selected.join(", ")}
                          MenuProps={MenuProps}
                        >
                          {grp.map((site) => (
                            <MenuItem key={site} value={site}>
                              <Checkbox
                                checked={
                                  excludedClients
                                    ? excludedClients.indexOf(site) > -1
                                    : false
                                }
                              />
                              <ListItemText primary={site} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                    className={classes.prodStatusInputsContainer}
                  >
                    <Grid item sm style={{ paddingTop: 0 }}>
                      <Grid
                        container
                        spacing={0}
                        direction="row"
                        style={{ flexFlow: "row nowrap" }}
                        justifyContent="space-between"
                      >
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          className={classes.formControl}
                        >
                          <InputLabel htmlFor="outlined-supplier">
                            Product Supplier*
                          </InputLabel>
                          <Select
                            margin="dense"
                            required
                            value={productSupplier}
                            onChange={(e) => handleSuppliersChange(e)}
                            label="Product Supplier"
                            inputProps={{
                              name: "supplier",
                              id: "outlined-supplier",
                            }}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {suppliersList.map((supplier) => (
                              <MenuItem
                                key={supplier.name}
                                value={supplier.name}
                              >
                                {supplier.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Supplier product={true} />
                      </Grid>
                    </Grid>
                    <Grid item sm style={{ paddingTop: 0 }}>
                      <Grid
                        container
                        spacing={0}
                        direction="row"
                        style={{ flexFlow: "row nowrap" }}
                        justifyContent="space-between"
                      >
                        <FormControl
                          margin="dense"
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <InputLabel htmlFor="brand-simple-select-outlined">
                            Product Brand*
                          </InputLabel>
                          <Select
                            required
                            margin="dense"
                            id="brand-simple-select-outlined"
                            value={selectedBrand}
                            onChange={(e) => handleBrandsChange(e)}
                            label="Product Brand"
                            inputProps={{
                              name: "brand",
                              id: "outlined-brand",
                            }}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {brandsList.map((brand) => (
                              <MenuItem key={brand.name} value={brand.name}>
                                {brand.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Brand product={true} />
                      </Grid>
                    </Grid>
                    <Grid item sm style={{ paddingTop: 0 }}>
                      <FormControl
                        variant="outlined"
                        margin="dense"
                        className={classes.formControl}
                      >
                        <InputLabel htmlFor="outlined-status-simple">
                          Product Status*
                        </InputLabel>
                        <Select
                          required
                          margin="dense"
                          value={productStatus}
                          onChange={(e) => handleStatusChange(e)}
                          label="Product Status"
                          inputProps={{
                            name: "status",
                            id: "outlined-status-simple",
                          }}
                        >
                          <MenuItem value="active">Active</MenuItem>
                          <MenuItem value="inactive">Inactive</MenuItem>
                          <MenuItem value="deleted">Deleted</MenuItem>
                          <MenuItem value="pending">Pending</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider style={{ marginTop: 16, marginBottom: 16 }} />
                <Grid
                  container
                  spacing={3}
                  direction="row"
                  justifyContent="space-between"
                  className={classes.prodStatusInputsContainer}
                >
                  {/* <Grid item sm={2} style={{ marginTop: 8 }}> */}
                  <Grid item sm>
                    <FormControlLabel
                      style={{ marginRight: 27 }}
                      control={
                        <Checkbox
                          checked={special}
                          onChange={(e) => setSpecial(!special)}
                          name="special"
                          color="primary"
                        />
                      }
                      label="Special"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={featured}
                          onChange={(e) => setFeatured(!featured)}
                          name="featured"
                          color="primary"
                        />
                      }
                      label="Featured"
                    />
                    {/* </Grid> */}
                    {/* <Grid item sm> */}
                    {/* </Grid> */}
                    <Grid
                      item
                      sm
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ColorButton onClick={openGroupingDialog}>
                        Edit Product Group
                      </ColorButton>
                    </Grid>
                  </Grid>
                  <Grid item sm>
                    <Grid
                      item
                      sm
                      className={classes.detailsItem}
                      margin="dense"
                    >
                      <TextField
                        key={product.specialOfferDescription}
                        defaultValue={
                          edit ? product.specialOfferDescription : ""
                        }
                        id="outlined-multiline-special-desc"
                        label="Special Description"
                        multiline
                        fullWidth
                        margin="dense"
                        rows={4}
                        variant="outlined"
                        onChange={(e) =>
                          setSpecialOfferDescription(e.target.value)
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid item sm>
                    <Grid
                      item
                      sm
                      className={classes.detailsItem}
                      margin="dense"
                    >
                      <TextField
                        key={product.specialSellingPrice}
                        defaultValue={
                          edit && product.specialSellingPrice
                            ? (product.specialSellingPrice / 100)
                                .toFixed(2)
                                .toString()
                            : ""
                        }
                        variant="outlined"
                        // margin="normal"
                        fullWidth
                        margin="dense"
                        id="code"
                        label="Special Selling Price ($)"
                        name="code"
                        autoComplete="text"
                        onChange={(e) => setSpecialSellingPrice(e.target.value)}
                      />
                    </Grid>
                    <Grid
                      item
                      sm
                      className={classes.detailsItem}
                      margin="dense"
                    >
                      <Datepicker
                        specialEndDate={specialEndDate}
                        setSpecialEndDate={setSpecialEndDate}
                      />
                    </Grid>
                  </Grid>
                  {/* </Grid> */}
                  <Divider style={{ marginTop: 16, marginBottom: 16 }} />
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                    className={classes.prodStatusInputsContainer}
                  ></Grid>
                </Grid>
              </Grid>
              {/* </Grid> */}
            </AccordionDetails>
          </Accordion>

          <Accordion className={classes.prodInfoContainer}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className={classes.heading}>Images</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid
                container
                spacing={3}
                direction="column"
                justifyContent="space-between"
                style={{ padding: 12, alignItems: "center" }}
              >
                <Grid item sm className={classes.dropzoneContainer}>
                  <DropZone filesCB={filesCB} />
                </Grid>
                {images &&
                  images
                    .filter(
                      (image) =>
                        !image.hasOwnProperty("imgType") ||
                        image.objName.includes("_520-0.jpeg") ||
                        image.objName.includes("_520-0.png")
                    )
                    .map((image, index) => (
                      <Grid
                        container
                        direction="row"
                        spacing={3}
                        justifyContent="space-between"
                        key={image.id}
                        style={{
                          maxWidth: 800,
                          marginBottom: 8,
                        }}
                      >
                        <Grid
                          item
                          sm={3}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            paddingLeft: 0,
                          }}
                        >
                          <img
                            src={
                              edit &&
                              product.images &&
                              product.images.filter(
                                (prodImage) => prodImage.id === image.id
                              ).length
                                ? `${process.env.REACT_APP_ASSETS_URL}/` +
                                  image.objName
                                : image.objName
                            }
                            width={150}
                            height={150}
                          />
                        </Grid>
                        <Grid item sm>
                          <Grid
                            key={index}
                            container
                            spacing={0}
                            direction="column"
                            justifyContent="space-between"
                          >
                            <Grid item sm style={{ paddingLeft: 0 }}>
                              <TextField
                                // key={image.title}
                                defaultValue={image.title}
                                className={classes.mediaDetails}
                                variant="outlined"
                                // margin="normal"
                                margin="dense"
                                id="media-title"
                                label="Title"
                                name="title"
                                autoComplete="text"
                                onChange={(e) =>
                                  updateMediaTitles(e.target.value, index)
                                }
                              />
                            </Grid>
                            <Grid item sm>
                              <TextField
                                // key={image.altText}
                                defaultValue={image.altText}
                                className={classes.mediaDetails}
                                variant="outlined"
                                // margin="normal"
                                margin="dense"
                                id="alt-text"
                                label="Alternative Text"
                                name="alt"
                                autoComplete="text"
                                onChange={(e) =>
                                  updateAltTexts(e.target.value, index)
                                }
                              />
                            </Grid>
                            <Grid item sm style={{ marginTop: 4 }}>
                              <Button
                                className={classes.mediaDetails}
                                variant="contained"
                                color="primary"
                                component="span"
                                onClick={(e) =>
                                  removeImage(e, image.objName, index)
                                }
                              >
                                Remove
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                {/* </Grid> */}
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion className={classes.prodInfoContainer}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className={classes.heading}>
                Product Update History
              </Typography>
            </AccordionSummary>

            <AccordionDetails
              style={{
                display: "flex",
                flexDirection: "column",
                padding: 12,
                alignItems: "center",
                maxHeight: 500,
                overflow: "scroll",
              }}
            >
              {/* <Grid
                container
                spacing={3}
                direction="column"
                justifyContent="space-between"
                style={{ display: 'flex', flexDirection: 'column', padding: 12, alignItems: "center", maxHeight: 500,}}
              > */}
              {[...productHistory].reverse().map((product, prodIndex) => (
                <Accordion
                  className={classes.prodInfoContainer}
                  style={{ width: "100%" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className={classes.heading}>
                      {new Intl.DateTimeFormat("en-AU", timeZoneOptions).format(
                        new Date(product.createdAt)
                      )}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      {Object.keys(product).map((key, index) => {
                        // if (prodIndex === 1) {
                        //   console.log("prodIndex", prodIndex);
                        //   console.log(
                        //     "productHistory[index - 1]",
                        //     [...productHistory].reverse()[prodIndex + 1]
                        //   );
                        //   console.log(
                        //     "productHistory[index - 1][key]",
                        //     [...productHistory].reverse()[prodIndex + 1][key]
                        //   );
                        //   console.log("product[key]", product[key]);
                        //   console.log(product[key] ===
                        //     [...productHistory].reverse()[prodIndex + 1][key])
                        // }
                        return (
                          <div
                            style={{
                              display: "flex",
                              borderBottom: "1px lightGrey solid",
                              fontSize: 12,
                              backgroundColor: [...productHistory].reverse()[
                                prodIndex + 1
                              ]
                                ? product[key] ===
                                  [...productHistory].reverse()[prodIndex + 1][
                                    key
                                  ]
                                  ? "white"
                                  : "yellow"
                                : "white",
                            }}
                          >
                            <div style={{ width: "30%", textAlign: "left" }}>
                              {key}
                            </div>
                            <div style={{ width: "70%", textAlign: "left" }}>
                              {product[key]}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
              {/* </Grid> */}
            </AccordionDetails>
          </Accordion>

          <ColorButton type="submit">
            {edit ? "Update Product" : "Create Product"}
          </ColorButton>
        </Container>
      </form>
      {/* )} */}
    </div>
  );
}
